/* eslint-disable @typescript-eslint/no-explicit-any */

window.Drupal.behaviors['languageSwitcher'] = {
    attach(context: Document | HTMLElement) {
        const languageSwitcher = document.querySelector<HTMLDivElement>('[data-language-switcher]');

        if (!languageSwitcher || languageSwitcher.dataset['languageSwitcherInitialized']) return;
        languageSwitcher.dataset['languageSwitcherInitialized'] = true.toString();

        const menu = languageSwitcher.querySelector<HTMLUListElement>('ul')!;
        languageSwitcher.querySelector<HTMLButtonElement>('button')!.addEventListener('click', () => {
            menu.classList.toggle('is-active');
        });

        const close = () => menu.classList.remove('is-active');

        document.addEventListener(
            'focus',
            (e) => {
                if (!menu.contains(e.target as Node)) {
                    close();
                }
            },
            true
        );
        document.addEventListener('click', (e) => {
            if (!languageSwitcher.contains(e.target as Node)) {
                close();
            }
        });
    },
};
